<section xmlns="http://www.w3.org/1999/html">
  <div [ngClass]="{'active': allPopup =='y' }" class="modal mmrgin" data-backdrop="static" data-keyboard="false" id="intialpopup"
       role="dialog" tabindex="-1">
    <div class="modal-dialog intialpopup-body">
      <div class="modal-content intialpopup-innerbody">
        <div class="carousel slide" data-ride="carousel" id="demo">
          <ul class="carousel-indicators cst_indicators mr-0 w  -25 col-8">
            <li *ngIf="!g.profilePopup.isMOUDocPresent" [ngClass]="{'active': mouPopup }" data-target="#demo"></li>
            <li *ngIf="!g.profilePopup.isKYCVerified" [ngClass]="{'active': kycPopup }" data-target="#demo"></li>
            <li *ngIf="!g.profilePopup.isDefaultAddressPresent" [ngClass]="{'active': addressPopup }"
                data-target="#demo"></li>
            <li *ngIf="!g.profilePopup.isChannelPresent" [ngClass]="{'active': channelPopup }" data-target="#demo"></li>
          </ul>

          <div class="carousel-inner">
            <div *ngIf="!g.profilePopup.isMOUDocPresent || g.profilePopup.isMOUVerified !== 'PENDING'" [ngClass]="{'active': mouPopup }"
                 class="carousel-item">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-11 intialpop">
                    <h4 class="intialpopup-heading">MOU document upload</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9" style="padding: 0px;">
                    <label [ngClass]="{'service-error':statusText}" class="upload_mou">
                      <input #file (change)="loadImage($event)" [(ngModel)]="uploadMou"
                             [ngModelOptions]="{standalone: true}" id="mou_upload" type="file"/>
                      <span *ngIf="!uploadMou || uploadMou == ''"><img alt="Upload MOU"
                                                                       src="/./assets/images/Group_1645.svg">MOU document upload</span>
                      <span *ngIf="uploadMou"><img src="/./assets/images/tick.svg"
                                                   style="width: 1.2em; margin-right:0.5em; margin-top: -30px; margin-left: 5px;"></span>
                    </label>
                    <p class="modal-text">At Shift, we believe in transparency for a successful business partnership.
                      Therefore, an MOU is necessary to the process.</p>
                    <p class="invest_text">You need to first download the MOU document that has been sent to your
                      registered email id. Please
                      sign it and upload above. You will receive a confirmation mail to your registered email id once
                      you have successfully</p>
                    <p class="invest_text">You will receive a confirmation mail to your registered email id once you
                      have successfully
                      submitted the document.</p>
                    <p class="modal-text">Note: If you haven’t received the document, you can also download it from
                      <a href="https://shift-images.s3.ap-south-1.amazonaws.com/Shift_WMS_MOU_DOC+(2).pdf"
                         target="_blank">here</a></p>
                  </div>
                  <div class="col deskContent">
                    <div class="img_post1"
                         style="background-image: url( /./assets/images/back_img.svg);">
                      <img alt="POST1" src="/./assets/images/post1.svg">
                    </div>
                  </div>
                  <div class="col MobileContent">
                    <div class="img_post1M" style="background-image: url( /./assets/images/moupost.svg);top:-435px;">

                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 90px;">
                  <div class="col-md-8" style="padding: 0px;">
                  </div>
                  <div class="col-md-4" style="padding: 0px;">
                    <button (click)="uploadMouDoc()" class="next" data-validate="mou">
                      {{(g.profilePopup.isKYCVerified &&
                      g.profilePopup.isDefaultAddressPresent && g.profilePopup.isChannelPresent)? 'Submit':'Next'}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!g.profilePopup.isKYCVerified || g.profilePopup.isKYCDocPresent != 'PENDING'" [ngClass]="{'active': kycPopup }"
                 class="carousel-item">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-11 intialpop">
                    <h4 class="intialpopup-heading">Let’s get you verified!</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6" style="padding: 0px;">
                    <label class="input_heads required"><b>Pancard </b><span class="text-danger">*</span><br>
                      <input (change)="checkPanNo()" (ngModelChange)="panCard = $event.toUpperCase()" [(ngModel)]="panCard" [ngClass]="{'service-error':statusText1}"
                             class="form-control input-border-radius  mr-2"
                             id="pan" maxlength="10"
                             onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 48 && event.charCode <= 57 || event.charCode >= 97 && event.charCode <= 122" placeholder="ABCDE1234F" type="text">
                      <span *ngIf="panNoerrorMessage" class="text-danger" style="position: absolute;"> {{panNoerrorMessage}}</span>
                    </label>
                    <label [ngClass]="{'service-error':statusText2}" class="upload_kyc" style="">
                      <input (change)="loadPancard($event)" [(ngModel)]="panCardPhoto" [ngModelOptions]="{standalone: true}"
                             id="pancard" type="file"/>
                      <span *ngIf="!panCardPhoto || panCardPhoto == ''"><img alt="panCardPhoto"
                                                                             src="/./assets/images/Group_1645.svg"> Upload Pan Card</span>
                      <span *ngIf="panCardPhoto"><img src="/./assets/images/tick.svg"
                                                      style="width: 1.2em; margin-right:0.5em; margin-top: -30px; margin-left: 5px;"></span>

                    </label>
                    <label class="input_heads"><b>Aadhar Card </b><span class="text-danger">*</span><br>
                      <input [(ngModel)]="aadhar" [ngClass]="{'service-error':statusText5}" [ngModelOptions]="{standalone: true}" class="mr-2"
                             id="aadharnumber"
                             maxlength="12" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                             placeholder="Enter Aadhar Card Number" type="text"/>
                    </label>
                    <label [ngClass]="{'service-error':statusText6}" class="upload_kyc" style="">
                      <input (change)="loadAadhar($event)" [(ngModel)]="aadharPhoto" [ngModelOptions]="{standalone: true}"
                             id="aadharcard" type="file"/>
                      <span *ngIf="!aadharPhoto || aadharPhoto == ''"><img alt="aadharPhoto"
                                                                           src="/./assets/images/Group_1645.svg"> Upload Aadhar Card</span>
                      <span *ngIf="aadharPhoto"><img src="/./assets/images/tick.svg"
                                                     style="width: 1.2em; margin-right:0.5em; margin-top: -30px; margin-left: 5px;"></span>

                    </label>
                    <label class="input_heads"><span>GST No. (Optional)</span><br>
                      <input [(ngModel)]="gstNo" [ngModelOptions]="{standalone: true}" placeholder="Enter ID Proof Number"
                             type="text"/>
                    </label>
                  </div>
                  <div class="col-md-3">
                    <p class="kyc_text">
                      KYC verification is now mandatory inorder to comply with the KYC regulations!</p>
                    <p class="invest_text">It's very simple! All you have to do is upload a picture of your valid PAN
                      card and Aadhar card
                      and you are good to go.</p>
                    <p class="invest_text">You will receive a confirmation mail to your registered email id once you
                      have successfully
                      submitted the documents.</p>
                  </div>
                  <div class="col-md-3 deskContent">
                    <div class="img_post3" style="background-image: url(/./assets/images/back_img.svg); top:-70px;">
                      <img alt="POST3" src=" /./assets/images/lock.svg">
                    </div>
                  </div>
                  <div class="col-md-3 MobileContent">
                    <div class="img_post3_1"
                         style="background-image: url(/./assets/images/back_img2.svg);top: -650px; width: 70px;">

                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 55px;">
                  <div class="col-md-4" style="padding: 0px;"></div>
                  <div class="col-md-8">
                    <button (click)="kycVerfication()" class="next" data-validate="kyc">
                      {{(g.profilePopup.isDefaultAddressPresent && g.profilePopup.isChannelPresent)? 'Submit':'Next'}}
                    </button>
                    <button (click)="resetPopUp()" *ngIf="!g.profilePopup.isMOUDocPresent"
                            class="btn btn-cancel float-right"
                            type="button">Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!g.profilePopup.isDefaultAddressPresent" [ngClass]="{'active': addressPopup }"
                 class="carousel-item">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-11 intialpop">
                    <h4 class="intialpopup-heading">Default Address</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9" style="padding: 0px;">
                    <p class="address_head">Billing Address</p>
                    <label class="input_heads_add"><b>Address 1 </b><span class="text-danger">*</span><br>
                      <input [(ngModel)]="address1" [ngClass]="{'service-error':statusText8}" [ngModelOptions]="{standalone: true}" class="mr-3"
                             id="address1" type="text"/>
                    </label>
                    <label class="input_heads_add" style=""><span>Address 2</span><br>
                      <input [(ngModel)]="address2" [ngModelOptions]="{standalone: true}" type="text"/>
                    </label>
                    <label class="input_heads_add"><b>City </b><span class="text-danger">*</span><br>
                      <ng-select [(ngModel)]="city" [items]="citiesList" class="mr-3"
                                 [ngClass]="{'service-error':statusText9}"
                                 [ngModelOptions]="{standalone: true}" bindLabel="label"
                                 bindValue="config"
                                 id="city"
                                 placeholder="city"
                                 required
                                 [addTag]="true"
                                 style="color:blue;width:300px;">
                      </ng-select>
                    </label>
                    <label class="input_heads_add"><b>State </b><span class="text-danger">*</span><br>
                      <ng-select [(ngModel)]="state" [items]="statesList"
                                 [ngClass]="{'service-error':statusText10}"
                                 [ngModelOptions]="{standalone: true}" bindLabel="label"
                                 bindValue="config"
                                 id="state"
                                 placeholder="state"
                                 required
                                 [addTag]="true"
                                 style="color:blue;width:300px;">
                      </ng-select>

                    </label>
                    <label class="input_heads_add"><b>Zipcode </b><span class="text-danger">*</span><br>
                      <input [(ngModel)]="zipCode" [ngClass]="{'service-error':statusText11}" [ngModelOptions]="{standalone: true}"
                             type="text"/>
                    </label>
                    <div class="add_check"><input (click)="createShipAddress()" type="checkbox"/>Use the same for
                      shipping
                    </div>
                  </div>
                  <div class="col-md-3 deskContent">
                    <div class="img_post4"
                         style="background-image: url(/./assets/images/back_img.svg);top:-70px">
                      <img alt="POST3" src=" /./assets/images/address_img.svg">
                    </div>
                  </div>
                  <div class="col-md-3 MobileContent">
                    <div class="img_post4_1"
                         style="background-image: url(/./assets/images/address_icon.svg); height:379px;width:70px;">
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 55px;">
                  <div class="col-md-4" style="padding: 0px;"></div>
                  <div class="col-md-8">
                    <button (click)="createAddress()" class="next" data-validate="address">
                      {{g.profilePopup.isChannelPresent? 'Submit':'Next'}}
                    </button>
                    <button (click)="resetPopUp()" *ngIf="!g.profilePopup.isMOUDocPresent || !g.profilePopup.isKYCVerified"
                            class="btn btn-cancel float-right"
                            type="button">Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!g.profilePopup.isChannelPresent" [ngClass]="{'active': channelPopup }" class="carousel-item">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-11 intialpop">
                    <h4 class="intialpopup-heading">Integrate your own Channels</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9" style="padding: 0px;">
                    <p (click)="closePopup()" class="investigate">Integrate your Own Channels</p>
                    <p class="invest_text"> You can integrate your eCom store or the Marketplaces where you sell your
                      products online, with shift for seamless synchronization of orders and products in a single
                      dashboard view.</p>
                    <p class="invest_text"> Navigate to the Integrations menu, click on new connection and select your
                      channel to configure, you may repeat this step in case of multiple connections and configure them
                      individually;
                      the detailed help instructions are available with-in each Channel creation section.</p>
                    <p class="invest_text"> If you have any questions regarding the instructions or need help, please
                      contact us at <br><b><a href="tel:+918904291440">+91 890 429 1440</a></b> or raise a ticket.</p>
                  </div>
                  <div class="col-md-3 deskContent">
                    <div class="img_post4" style="background-image: url( /./assets/images/back_img.svg); top:-70px">
                      <img alt="POST3" src=" /./assets/images/integrate.svg">
                    </div>
                  </div>
                  <div class="col-md-3 MobileContent">
                    <div class="img_post4_2"
                         style="background-image: url( /./assets/images/mintegrate.svg);top:-435px;width: 70px;">

                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 70px;">
                  <div class="col-md-4" style="padding: 0px;">
                  </div>
                  <div class="col-md-8">
                    <button (click)="skipPopUp()" class="skip" data-validate="shipping">Skip</button>
                    <button (click)="resetPopUp()" *ngIf="!g.profilePopup.isMOUDocPresent || !g.profilePopup.isKYCVerified || !g.profilePopup.isDefaultAddressPresent"
                            class="btn btn-cancel float-right"
                            type="button">Back
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<script>
  $(function () {
     $('.modal').modal({
      show:true,
      keyboard: false,
      backdrop: 'static'
    });
});




</script>
